import styled, { css } from 'styled-components';

export const StyledLayout = styled.div`
  ${({ $showlayout, $isChatRoute }) =>
    $showlayout
      ? css`
          display: flex;
          align-items: stretch;
          min-height: 100dvh;

          .children {
            flex: 1;
            min-width: 0;
            height: 100dvh;
            display: flex;
            flex-direction: column;
            overflow-y: ${$isChatRoute ? 'hidden' : 'auto'};
            padding: ${$isChatRoute ? '0' : '16px'};
            padding-top: ${$isChatRoute ? '0' : '64px'};
            background: var(--body-bg);
            color: var(--text-main);

            .view-loader-shell {
              flex: 1;
              min-height: 0;
              width: 100%;
              display: flex;
              flex-direction: column;
            }

            .view-loader-shell > div {
              min-height: 0 !important;
              flex: 1 1 auto;
            }

            @media (min-width: 768px) {
              padding: ${$isChatRoute ? '0' : '24px'};
              padding-top: ${$isChatRoute ? '0' : '64px'};
            }

            @media (min-width: 1200px) {
              padding: ${$isChatRoute ? '0' : '40px'};
            }
          }
        `
      : css`
          padding: 0;

          .children {
            width: 100%;
          }
        `}
`;
